import { company } from '../../company/Company';

export const DEFAULT_PLACEHOLDER = company.config.phonePlaceholder;
